import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const JumpIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "jump",
  "JumpIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M7.33008 3.33032H3.33008V12.6697H4.66341V12.6637H11.3301V12.6697H12.6634L12.6634 8.66968H11.3301V11.3303H4.66341L4.66341 4.66366H7.33008V3.33032Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M8.66943 3.33032H12.6694V7.33032L11.1408 5.8017L7.80145 9.14105L6.85864 8.19824L10.198 4.85889L8.66943 3.33032Z" fill={colorList[0]} fillOpacity="0.9"/></g></svg>
);

export default JumpIcon;
